"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StopWatch = void 0;
var stopwatch_1 = require("./stopwatch");
Object.defineProperty(exports, "StopWatch", { enumerable: true, get: function () { return stopwatch_1.StopWatch; } });
//# sourceMappingURL=index.js.map